const PSEvents = require('PSEvents');
const { MenuElements, getMenuElement } = require('SlotUI');
const i18n = require('i18n');

cc.Class({
    extends: cc.Component,

    properties: {
        netPositionContainer: cc.Node,
        amount: cc.Label,
    },

    onLoad() {
        this.netPositionContainer.active = false;
        PSEvents.getLastOrSubscribe(PSEvents.GENERIC_SHOW, (data) => {
            const uiData = getMenuElement(MenuElements.NetPosition);
            if (uiData.enabled && !uiData.emptyData) {
                this.init(data);
            } else {
                this.netPositionContainer.destroy();
            }
        });
    },

    init (initialData) {
        this.netPositionContainer.active = true;
        this.updateValue(initialData);

        PSEvents.subscribe(PSEvents.ROUND_ANIMATION_ENDED, () => {
            const data = PSEvents.getLast(PSEvents.SPIN_RESPONSE);

            this.updateValue(data);
        });
    },

    updateValue(data) {
        if (!data) {
            console.warn('net position data is missing ', data);
            return;
        }
        if (!data.hasOwnProperty('netPosition')) {
            console.warn('data "netPosition" property is missing ', data);
            this.amount.string = '';
            return;
        }
        if (!data.netPosition.hasOwnProperty('netProfit')) {
            console.warn('data "profit" property is missing ', data);
            this.amount.string = '';
            return;
        }
        const { netProfit } = data.netPosition; // bets, wins, netProfit
        this.amount.string = i18n.formatCurrency(netProfit);
    },
});
